import { iIconProps } from '../../icon';

export default function TwitterIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 40 40' {...props}>
            <path d='M36 10.078c-1.19.522-2.458.868-3.78 1.036a6.523 6.523 0 002.886-3.626 13.11 13.11 0 01-4.16 1.588A6.574 6.574 0 0026.154 7c-3.632 0-6.556 2.948-6.556 6.562 0 .52.044 1.02.152 1.496-5.454-.266-10.28-2.88-13.522-6.862a6.605 6.605 0 00-.898 3.316 6.57 6.57 0 002.914 5.452 6.479 6.479 0 01-2.964-.808v.072c0 3.188 2.274 5.836 5.256 6.446a6.548 6.548 0 01-1.72.216 5.8 5.8 0 01-1.242-.112c.85 2.598 3.262 4.508 6.13 4.57a13.182 13.182 0 01-8.134 2.798c-.538 0-1.054-.024-1.57-.09A18.469 18.469 0 0014.064 33c12.072 0 18.672-10 18.672-18.668 0-.29-.01-.57-.024-.848A13.087 13.087 0 0036 10.078z' />
        </svg>
    );
}
